export default __webpack_public_path__ + "static/media/logo.1ad2a992.svg";